import { styled } from 'styled-components';

import { Container } from '../Layout';
import { Text } from '../Text';
import { theme } from '../../styles';
import { Colors, getColor } from '../../utils';

const DottedContainer = styled(Container)`
  overflow: hidden;
  overflow-x: hidden;
  padding: 0;
  ${theme.typography.textSmall}
  &::before {
    float: left;
    width: 0;
    white-space: nowrap;
    color: #706f6f;
    content: '...........................................................................................................................................................................................................................................................';
  }
`;

export const DateWithDots = ({
  text,
  date,
  backgroundColor,
}: {
  text: string;
  date: string;
  backgroundColor: Colors;
}) => (
  <DottedContainer>
    <Text
      size="small"
      color="black"
      style={{
        backgroundColor: getColor(backgroundColor),
        float: 'left',
        paddingRight: '4px',
      }}
    >
      {text}
    </Text>
    <Text
      size="small"
      color="black"
      style={{
        backgroundColor: getColor(backgroundColor),
        float: 'right',
        paddingLeft: '4px',
      }}
    >
      {date}
    </Text>
  </DottedContainer>
);
